module.exports = __webpack_public_path__ + "pc/img/work_detail7.7e6895f5.jpg";